<template>
  <v-container fluid>
    <v-form ref="form" v-if="candidato">
      <div class="subtitle-1 font-weight-bold mb-2">
        Selecione o motivo da solicitação:
      </div>
      <v-radio-group v-model="motivoSelecionado" :rules="motivoRules">
        <v-radio
          v-for="motivo in motivos"
          :key="motivo"
          :label="motivo"
          :value="motivo"
        ></v-radio>
      </v-radio-group>

      <v-btn
        class="info mt-4"
        rounded
        depressed
        min-width="130"
        :loading="atualizando"
        @click="finalizarSolicitacao"
        >Finalizar<v-icon class="ml-2">mdi-check</v-icon>
      </v-btn>
      <v-btn text rounded small class="ml-2 mt-4" @click="setStep(2)"
        >Anterior</v-btn
      >
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";

export default {
  computed: mapState("candidaturainterna", [
    "candidato",
    "tipoSelecao",
    "vagaSelecionada",
  ]),
  data: () => ({
    motivoRules: [(v) => !!v || "Selecione um motivo"],
    atualizando: false,
    motivoSelecionado: null,
    motivos: [
      "Perspectiva Aumento Salarial",
      "Perspectiva de evolução Profissional",
      "Adequação de horario",
      "Mudança de função",
    ],
  }),
  methods: {
    ...mapMutations("candidaturainterna", ["setStep"]),
    // async finalizarSolicitacao() {
    //   if (!this.$refs.form.validate()) return;

    //   console.log("finalizarSolicitacao");
    //   this.atualizando = true;
    //   try {
    //     // 1) se for VAGA, registra candidatura (idVaga)
    //     if (this.tipoSelecao === "VAGA") {
    //       if (!this.vagaSelecionada?.id) {
    //         this.$toasted.error("Selecione uma vaga antes de finalizar.");
    //         this.setStep(2);
    //         return;
    //       }

    //       await axios.post(
    //         "/colaborador/candidatura-vagas?funcao=CANDIDATAR-VAGA",
    //         { idVaga: this.vagaSelecionada.id }
    //       );
    //     }

    //     console.log("finalizarSolicitacao antes do HCM ATUALIZAR");

    //     // 2) sempre salva motivo no HCM
    //     const res = await axios.post(
    //       "/colaborador/candidatura-interna?funcao=ATUALIZAR-EXPECTATIVAS",
    //       { observacao: this.motivoSelecionado }
    //     );

    //     if (res.data?.success) {
    //       this.setStep(1);
    //       this.$toasted.success("Solicitação finalizada com sucesso");
    //     } else {
    //       this.$toasted.error(res.data?.msg || "Falha ao finalizar");
    //     }
    //   } catch (e) {
    //     this.$toasted.error("Falha ao finalizar solicitação");
    //   } finally {
    //     this.atualizando = false;
    //   }
    // },

    async finalizarSolicitacao() {
      if (!this.$refs.form.validate()) return;

      this.atualizando = true;

      try {
        // Se for VAGA: antes de tudo, grava a vaga/área no HCM (igual Banco)
        if (this.tipoSelecao === "VAGA") {
          const tag = this.vagaSelecionada?.tagVaga;

          if (!tag) {
            this.$toasted.error(
              "Vaga selecionada sem Tag. Recarregue e tente novamente."
            );
            this.setStep(2);
            return;
          }

          // grava no HCM o interesse (mesma rota do banco de talentos)
          const resArea = await axios.post(
            "/colaborador/candidatura-interna?funcao=ATUALIZAR-AREAS-INTERESSE",
            { areas: [tag] }
          );

          if (!resArea.data?.success) {
            this.$toasted.error(
              resArea.data?.msg || "Falha ao salvar a vaga/área de interesse"
            );
            return;
          }

          if (this.vagaSelecionada?.id) {
            await axios.post(
              "/colaborador/candidatura-vagas?funcao=CANDIDATAR-VAGA",
              {
                idVaga: this.vagaSelecionada.id,
                observacao: this.motivoSelecionado,
              }
            );
          }
        }

        // Sempre salva motivo no HCM
        const res = await axios.post(
          "/colaborador/candidatura-interna?funcao=ATUALIZAR-EXPECTATIVAS",
          { observacao: this.motivoSelecionado }
        );

        if (res.data?.success) {
          this.setStep(1);
          this.$toasted.success("Solicitação finalizada com sucesso");
        } else {
          this.$toasted.error(res.data?.msg || "Falha ao finalizar");
        }
      } catch (e) {
        this.$toasted.error("Falha ao finalizar solicitação");
      } finally {
        this.atualizando = false;
      }
    },
  },
  mounted() {
    if (this.candidato && this.candidato.observacao) {
      // Verifica se a observação salva é um dos motivos válidos
      if (this.motivos.includes(this.candidato.observacao)) {
        this.motivoSelecionado = this.candidato.observacao;
      }
    }
  },
};
</script>
